import "./gender.scss";
import "./genderResponsive.sass";
import {Link, NavLink, useHistory, useLocation} from "react-router-dom";
import { Hero } from "../../container/index";
import React, { useState } from "react";
import { News, Helm } from "../../components/index";
import { useEffect } from "react";
import { request } from "../../api/request";
import TomchiLogo from '../../assets/icons/TOMCHILOGO.png'
import { useDispatch } from "react-redux";
import { set_data } from "../../redux/action";
import { useSelector } from "react-redux";
import parser from "html-react-parser";
import QRcode from '../../assets/qrCode.png'
const Gender = () => {

    const dispatch = useDispatch();

    const event = useSelector((state) => state.data.data);
    const lang = useSelector((state) => state.data.lang);
    const news = useSelector(state => state.data.news)
    const [categories, setCategories] = useState([])

    const [active, setActive] = useState(0)

    const history = useHistory();
    const location = useLocation();
    const currentPath = location.pathname;

    useEffect(() => {
        request
            .get(`/content/all/event?sort=DESC&sortby=id&lang=${lang === null ? "uz" : lang}`, {
                headers: {
                    "api-token": "p12378",
                },
            })

            .then((res) => dispatch(set_data(res.data)))
            .catch((err) => console.log(err));

        request
            .get(`/segment/all/event_category?lang=${lang === null ? "uz" : lang}`, {
                headers: {
                    "api-token": "p12378",
                },
            })

            .then((res) => setCategories(res.data))
            .catch((err) => console.log(err));
    }, [lang]);
    return (
        <div className="events-page">
            {/*<Helm id={"37"}/>*/}

            <div className="hero-page">
                <Hero
                    id={"663"}
                    nameOne={
                        lang === "uz"
                            ? "Bosh sahifa"
                            : lang === "ru"
                                ? "Домой"
                                : lang === "en"
                                    ? "Home page"
                                    : ""
                    }
                    nameTwo={
                        lang === "uz"
                            ? "Gender konsepsiyasi"
                            : lang === "ru"
                                ? "Открытые данные"
                                : lang === "en"
                                    ? "Open data"
                                    : ""
                    }
                    linkOne={"/"}
                    linkTwo={"/gender-konsepsiya"}
                />
            </div>

            <div className="inner-pages container">
                <div className="col-one">
                    <div className="heading">
                        <h1 className="news-holder">Kategoriya</h1>
                    </div>
                    <div className="events-category">
                        <button
                            onClick={() => history.push('/gender-konsepsiya')}
                            className={currentPath === '/gender-konsepsiya' ? 'active' : ''}
                        >
                            Gender konsepsiyasi
                        </button>
                        <button
                            onClick={() => history.push('/gender-material')}
                            className={currentPath === '/gender-material' ? 'active' : ''}
                        >
                            Rasmiy taqdimot materiallari
                        </button>
                        <button
                            onClick={() => history.push('/gender-hikoya')}
                            className={
                                currentPath === '/gender-hikoya' ||
                                currentPath === '/gender-hikoya-1' ||
                                currentPath === '/gender-hikoya-2'
                                    ? 'active'
                                    : ''
                            }
                        >
                            Loyiha hikoyalari
                        </button>
                    </div>
                    <div className="tomchi">
                        <img src={QRcode} alt=""/>
                    </div>
                    <div className="tomchi-links">
                        <img src={TomchiLogo} alt=""/>
                        <h3 style={{
                            fontSize: '13px'
                        }} className='tomchi-title'>QR code skanerlang va Tomchi mobil ilovasini yuklab oling.</h3>
                    </div>
                </div>

                <div className="col-two">
                    <div className="heading">
                        <h1 className="news-holder">Suv xo'jaligida gender konsepsiyasi</h1>
                    </div>
                    <h2 style={{textAlign: "center", marginBottom: "10px"}}>Suv va tenglik uchun yangi bosqich:
                        O‘zbekistonning 2025–2030
                        yillarga mo‘ljallangan Gender konsepsiyasi bilan mening sayohatim</h2>
                    <p style={{textIndent: "20px", textAlign: "justify", marginBottom: "12px"}}>
                        Muallif: Shahla Ismoil, Osiyo Taraqqiyot Bankining xalqaro maslahatchisi
                    </p>
                    <p style={{textIndent: "20px", textAlign: "justify", marginBottom: "12px"}}>
                        Menga O‘zbekiston suv sohasi uchun Gender konsepsiyasini ishlab chiqish jarayoniga qo‘shilish
                        taklifi kelib tushganida, bu ishlar ahamiyatli bo‘lishini bilardim — ammo bu sayohat qay
                        darajada tarixiy ahamiyat kasb etishini o‘shanda hali anglab etmagan edim.
                    </p>
                    <p style={{textIndent: "20px", textAlign: "justify", marginBottom: "12px"}}>
                        Gender tengligi va institutsional islohotlar kesishmasida yillar davomida ishlagan mutaxassis
                        sifatida, bu mavzularni suv resurslarini boshqarish kabi yuqori texnik sohalarda integratsiya
                        qilish qanchalik murakkab ekanini yaxshi bilaman. Shunga qaramay, O‘zbekiston bu ishga jiddiy
                        yondashgani boshidanoq ma’lum edi. Suv xo‘jaligi vazirligi milliy va xalqaro mutaxassislar bilan
                        birgalikda tizimli va jasur o‘zgarishlarni amalga oshirishga tayyor edi.
                    </p>
                    <img src="https://wsrc-assets.wsrc.uz/uploads/2025/iyun/screenshot2.webp" alt="AS"
                         style={{width: "100%"}}/>
                    <p style={{textIndent: "20px", textAlign: "justify", marginBottom: "12px"}}>
                        “Ushbu dasturda ishtirok etish men uchun katta sharaf bo‘ldi… Gender konsepsiyasi noyob
                        hujjatdir — amalda mintaqadagi birinchi shunday hujjatlardan biri — u suv sohasida erkaklar va
                        ayollar o‘rtasida tenglikka erishish uchun eng yaxshi global standartlarni birlashtiradi. Bunday
                        tajribalarga ega davlatlar dunyoda atigi 80 ta atrofida, va men chin dildan O‘zbekistonning
                        ularning qatorida bo‘lishidan xursandman.”<br/>
                        — Shahla Ismoil
                    </p>

                    <p style={{textIndent: "20px", textAlign: "justify", marginBottom: "12px"}}>
                        Ushbu ishning yuragida oddiy, lekin kuchli g‘oya yotadi: suv siyosati har bir insonning —
                        ayollar va erkaklar, yosh va qari, shaharlik va qishloqlik — ehtiyojlari, ovozlari va
                        haqiqatlarini aks ettirishi kerak. Ana shunday ishni aynan mana shu konsepsiya amalga oshiradi.
                    </p>

                    <p style={{textIndent: "20px", textAlign: "justify", marginBottom: "12px"}}>
                        Biz taqdim etgan hujjat O‘zbekistonda birinchi marta tayyorlangan strategik reja hisoblanadi. U
                        gender tengligini suv boshqaruvining har bir darajasida — institutsional rahbarlikdan maydon
                        darajasidagi amaliyotgacha — mustahkamlash uchun aniq maqsadlar va besh yillik harakatlar
                        rejasini belgilaydi.
                    </p>

                    <p style={{textIndent: "20px", textAlign: "justify", marginBottom: "12px"}}>
                        Konsepsiyaning rasmiy taqdimotida — Vazirlikdagi Gender Kengashi kengaytirilgan yig‘ilishi
                        davomida o‘tkazilgan — xonani noyob ruhiyat qamrab oldi: iftixor, maqsad va umumiy mas’uliyat
                        tuyg‘usi. Hukumat, rivojlanish agentliklari va fuqarolik jamiyati rahbarlari barchasi bir
                        ovozdan shunday dedi: bu juda muhim.
                    </p>
                    <img src="https://wsrc-assets.wsrc.uz/uploads/2025/iyun/screenshot3.webp" alt="AS"
                         style={{width: "100%"}}/>
                    <p style={{textIndent: "20px", textAlign: "justify", marginBottom: "12px"}}>
                        “Ta’lim olgan va malakali ayollar ulushini oshirish barcha sohalarda muhim masalaga
                        aylanmoqda... Suv sohasida esa bizda 2025–2030 yillarga mo‘ljallangan Gender konsepsiyasi bor, u
                        rasmiy tasdiqlangan va amaliy harakatlarga asoslangan. Eng muhim jihati — uning doimiy, yil
                        sayin amalga oshirilishi, to‘liq monitoring va parlament nazorati ostida bo‘lishidir.”<br/>
                        — Dilorom Fayziyeva, O‘zbekiston Oliy Majlisi Qonunchilik palatasi deputati
                    </p>

                    <p style={{textIndent: "20px", textAlign: "justify", marginBottom: "12px"}}>
                        Xalqaro hamkorlarning qo‘llab-quvvatlashi juda muhim rol o‘ynadi. Ularning ishtiroki
                        O‘zbekistonning qarashlarini jahonning eng yaxshi amaliyotlari bilan bog‘lashga yordam berdi —
                        va bu faqat mahalliy islohot emas, balki inklyuziv suv boshqaruvi uchun kengroq, xalqaro
                        harakatning bir qismi ekanini mustahkamladi.
                    </p>

                    <p style={{textIndent: "20px", textAlign: "justify", marginBottom: "12px"}}>
                        Ushbu ish Suv xo’jaligi vazirligi, Shveysariya rivojlanish va hamkorlik agentligi, Osiyo
                        Taraqqiyot Banki hamda turli ekspertlar hamkorligi orqali amalga oshirildi.
                    </p>

                    <p style={{textIndent: "20px", textAlign: "justify", marginBottom: "12px"}}>
                        “Ushbu hujjatni ayniqsa muhim qiladigan jihat shundaki, u keyingi besh yil uchun harakatlar
                        rejasini o‘z ichiga oladi va turli ishtirokchilar tomonidan qanday choralar ko‘rilishi
                        kerakligini aniq belgilaydi.”
                    </p>

                    <div className="two-column">
                        <div className="image-side">
                            <img
                                src="https://wsrc-assets.wsrc.uz/uploads/2025/iyun/screenshot4.webp"
                                alt="AS"
                            />
                        </div>
                        <div className="text-side">
                            <p>
                                Bu O‘zbekistonda inklyuziv suv boshqaruvi uchun konseptual va inson markazidagi asosni
                                ta’minlaydi — suv xizmatlari har bir insonning ehtiyojlariga yaxshiroq moslashishini
                                kafolatlaydi.
                            </p>
                            <p>
                                Biz O‘zbekistonni ushbu muhim va o‘z vaqtida tashabbusda qo‘llab-quvvatlaganimizdan
                                faxrlanamiz.
                            </p>
                            <p className="author">— Andrin Fink, Missiy boshlig’ining o‘rinbosari, Hamkorlik bo‘limi boshlig‘i, SDC</p>
                        </div>
                    </div>

                    <p style={{textIndent: "20px", textAlign: "justify", marginBottom: "12px"}}>
                        Albatta, bularning hech biri orqa fonda fidoyi jamoasiz mumkin bo‘lmas edi. Konsepsiya bir
                        necha oy davomida turli soha va fanlardan vakillarni birlashtirgan ishchi guruh tomonidan
                        shakllantirildi — haqiqiy o‘zgarishlar qilishga sodiq bo‘lgan odamlar.
                    </p>

                    <div className="two-column">
                        <div className="image-side">
                            <img
                                src="https://wsrc-assets.wsrc.uz/uploads/2025/iyun/screenshot5.webp"
                                alt="AS"
                            />
                        </div>
                        <div className="text-side">
                            <p>
                                “Ushbu Konsepsiya O‘zbekiston Konstitutsiyasida va 2030 strategiyasida
                                belgilangan maqsadlarni amalga oshirishga qaratilgan amaliy qadamdir.
                                Uning eng kuchli jihatlaridan biri shundaki, suv boshqaruvida ayollarning
                                ovozi, ko‘nikmalari va bilimlari barcha darajadagi qaror qabul qilish
                                jarayoniga kiritilishi kerakligi tan olingan. Bu faqat institutlar haqida
                                emas — bu suv foydalanuvchilari, butun jamiyatlarning ehtiyojlari
                                haqida.”
                            </p>
                            <p className="author">— Dinara Ziganshina, Ishchi guruh koordinatori</p>
                        </div>
                    </div>

                    <img src="https://wsrc-assets.wsrc.uz/uploads/2025/iyun/screenshot6.webp" alt="AS"
                         style={{width: "100%"}}/>
                    <p style={{textIndent: "20px", textAlign: "justify", marginBottom: "12px"}}>
                        Taqdimot vaqtida hamkasblarim bilan birga turganimda, men bu kabi ishda kamdan-kam his qiladigan
                        narsani his qildim: haqiqiy sadoqatga asoslangan umid. O‘zbekiston nafaqat oldinga qadam
                        qo‘ymoqda — balki mintaqadagi boshqalar uchun namunani taklif qilmoqda.
                    </p>

                    <p style={{textIndent: "20px", textAlign: "justify", marginBottom: "12px"}}>
                        “Bu O‘zbekistonda o‘ziga xos birinchi hujjat bo‘lishi mumkin, lekin men ishonchim komilki, u
                        an’anaga aylanishi mumkin — kengroq mintaqa va boshqa sohalar uchun namunaga... O‘zbekiston
                        rivojlanishi haqiqiy qo‘shnichilik va hamkorlik timsolidir.”<br/>
                        — Shahla Ismoil
                    </p>

                    <p style={{textIndent: "20px", textAlign: "justify", marginBottom: "12px"}}>
                        Bu sayohatning oxiri emas — boshlanishidir. Asl ish endi boshlanadi: amalga oshirish,
                        mas’uliyat, transformatsiya. Ammo poydevor mustahkam, va qarash aniq.
                    </p>


                </div>

                <div className="col-thr">
                    <h1 className="news-holder">
                        {lang === "uz"
                            ? "So’ngi yangiliklar"
                            : lang === "ru"
                                ? "последние новости"
                                : lang === "en"
                                    ? "Last news"
                                    : ""}
                    </h1>
                    {news && news.status === 1 ? (
                        news.data &&
                        news.data.map((el, index) => (
                            <News
                                date={el.created_on}
                                key={index}
                                title={el.title}
                                id={el.id}
                            />
                        ))
                    ) : (
                        <h1>Loading ...</h1>
                    )}
                </div>
            </div>

            <div className="margin"></div>
        </div>
    );
};

export default Gender;
